import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=2f14488d&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=js&"
export * from "./Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14488d",
  null
  
)

export default component.exports